import {Button, Divider, Grid} from "@mantine/core";
import {IconArrowsSplit} from "@tabler/icons-react";
import {useTranslation} from "react-i18next";

export type SplitActionsProps = {
  pickupDisabled?: boolean
  deliveryDisabled?: boolean
  onAddSplitActionClick: (type: "PICKUP" | "DELIVERY") => void
}

export const SplitActions = (props: SplitActionsProps) => {
  const {onAddSplitActionClick, pickupDisabled, deliveryDisabled} = props;

  const {t} = useTranslation(["common"]);

  return (
    <>
      <Divider my="sm" variant="dotted"/>
      <Grid grow gutter="xs">
        {!pickupDisabled &&
          <Grid.Col span={6}>
            <Button
              mt="md"
              variant="light"
              rightIcon={<IconArrowsSplit/>}
              onClick={e => onAddSplitActionClick("PICKUP")}>
              {t("common.entity.dispatch.form.action.addsplit.pickup", "Add Pickup Split")}
            </Button>
          </Grid.Col>
        }
        {!deliveryDisabled &&
          <Grid.Col span={6}>
            <Button
              mt="md"
              variant="light"
              rightIcon={<IconArrowsSplit/>}
              onClick={e => onAddSplitActionClick("DELIVERY")}>
              {t("common.entity.dispatch.form.action.addsplit.delivery", "Add Delivery Split")}
            </Button>
          </Grid.Col>
        }
      </Grid>
    </>
  )
}
